<section class="container-fluid min-height-container bg-gray-100 pb-5">
    <section class="container pt-5 position-relative">
        @if(loading()) {
            <app-loading-overlay></app-loading-overlay>
        }
        @if(!displaySuccessMessage()) {
        <div class="row">
            <div class="col-md-6 offset-md-3 py-0">
                <h1 class="text-center display-2 mb-0" id="joinNow">Join Now</h1>
                <a class="text-center text-black d-block fs-4" routerLink="/providers" fragment="joinNow">I'm a Provider</a>
            </div>
        </div>
        <form #patientApplication="ngForm" class="row g-3 my-5" (ngSubmit)="submit(patientApplication)" novalidate>
            <div class="col-md-4 offset-md-2">
                <label for="first_name" class="form-label required">First Name</label>
                <input
                    type="text"
                    class="form-control"
                    id="first_name"
                    name="first_name"
                    [(ngModel)]="formData.first_name"
                    #first_name="ngModel"
                    required
                    minlength="2"
                    [class.is-invalid]="first_name.invalid && first_name.touched"
                >
            </div>
            <div class="col-md-4">
                <label for="last_name" class="form-label required">Last Name</label>
                <input
                    type="text"
                    class="form-control"
                    id="last_name"
                    name="last_name"
                    [(ngModel)]="formData.last_name"
                    #last_name="ngModel"
                    required
                    minlength="2"
                    [class.is-invalid]="last_name.invalid && last_name.touched">
            </div>
            <div class="col-md-4 offset-md-2">
                <label for="dob" class="form-label required">Date of Birth</label>
                <input
                    type="date"
                    class="form-control"
                    id="dob"
                    name="dob"
                    [(ngModel)]="formData.dob"
                    #dob="ngModel"
                    (ngModelChange)="clearError()"
                    required
                    min="1900-01-01"
                    [max]="todayIso"
                    [class.is-invalid]="(dob.invalid || isFutureDate(formData.dob)) && dob.touched"
                >
                @if (isFutureDate(formData.dob) && dob.touched) {
                    <div class="invalid-feedback d-block">
                        Date of Birth cannot be in the future.
                    </div>
                }
            </div>
            <div class="col-md-4">
                <label for="email_address" class="form-label required">E-Mail Address</label>
                <input
                    type="email"
                    class="form-control"
                    id="email_address"
                    name="email_address"
                    [(ngModel)]="formData.email_address"
                    #email_address="ngModel"
                    required
                    email
                    [class.is-invalid]="email_address.invalid && email_address.touched"
                >
            </div>
            <div class="col-md-4 offset-md-2">
                <label for="phone" class="form-label required">Phone Number</label>
                <input
                    type="tel"
                    class="form-control"
                    id="phone"
                    name="phone"
                    [ngModel]="formatPhoneNumber(formData.phone)"
                    (ngModelChange)="onPhoneInput($event)"
                    #phone="ngModel"
                    required
                    pattern="^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$"
                    maxlength="14"
                    [class.is-invalid]="phone.invalid && phone.touched"
                >
            </div>
            <div class="col-md-8 offset-md-2 mt-5">
                <label for="address" class="form-label required">Address</label>
                <input
                    type="text"
                    class="form-control"
                    id="address"
                    name="address"
                    [(ngModel)]="formData.address"
                    #address="ngModel"
                    required
                    [class.is-invalid]="address.invalid && address.touched"
                >
            </div>
            <div class="col-md-8 offset-md-2">
                <label for="address2" class="form-label">Address Line 2</label>
                <input type="text" name="address2" class="form-control" id="address2" [(ngModel)]="formData.address2">
            </div>
            <div class="col-md-4 offset-md-2">
                <label for="city" class="form-label required">City</label>
                <input
                    type="text"
                    class="form-control"
                    id="city"
                    name="city"
                    [(ngModel)]="formData.city"
                    #city="ngModel"
                    required
                    minlength="2"
                    [class.is-invalid]="city.invalid && city.touched"
                >
            </div>
            <div class="col-md-4">
                <label for="state" class="form-label required">State</label>
                <select
                    class="form-control"
                    id="state"
                    name="state"
                    [(ngModel)]="formData.state"
                    #state="ngModel"
                    required
                    [class.is-invalid]="state.invalid && state.touched">
                    <option value="">-- Select a State --</option>
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="DC">District of Columbia</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>
                </select>
            </div>
            <div class="col-md-4 offset-md-2">
                <label for="zip_code" class="form-label required">Zip Code</label>
                <input
                    type="text"
                    class="form-control"
                    id="zip_code"
                    name="zip_code"
                    [(ngModel)]="formData.zip_code"
                    #zip_code="ngModel"
                    required
                    pattern="[0-9]{5}"
                    [class.is-invalid]="zip_code.invalid && zip_code.touched"
                >
            </div>
            <div class="col-md-8 offset-md-2 my-5">
                <label for="plan_type" class="form-label required">Choose Plan</label>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                type="radio"
                                name="plan_type"
                                id="plan1"
                                value="Individual"
                                [(ngModel)]="formData.plan_type"
                                (change)="onPlanTypeChange()"
                                required>
                            <label class="form-check-label" for="plan1">
                                Individual
                            </label>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                type="radio"
                                name="plan_type"
                                id="plan2"
                                value="IndividualPlus"
                                [(ngModel)]="formData.plan_type"
                                (change)="onPlanTypeChange()">
                            <label class="form-check-label" for="plan2">
                                Individual + Spouse
                            </label>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                type="radio"
                                name="plan_type"
                                id="plan3"
                                value="Family"
                                [(ngModel)]="formData.plan_type"
                                (change)="onPlanTypeChange()">
                            <label class="form-check-label" for="plan3">
                                Family
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            @if(formData.plan_type !== 'Individual' && formData.plan_type) {
                @if(!formData.dependents.length) {
                    <div class="col-12 col-md-4 offset-md-4">
                        <button type="button" class="btn btn-black w-100" (click)="addDependant()">Begin Adding Dependent(s)</button>
                    </div>
                }
                @for(d of formData.dependents; track d; let i = $index) {
                    <div class="col-md-8 offset-md-2">
                    @if(i === 0) {
                        <label for="dependents" class="form-label">Dependants</label>
                    }

                        <div class="row">
                            <div class="col-md-6">
                                <label [for]="'first_name_' + i" class="form-label required">First Name</label>
                                <input
                                    type="text"
                                    [name]="'first_name_' + i"
                                    class="form-control"
                                    [id]="'first_name_' + i"
                                    [(ngModel)]="formData.dependents[i].first_name"
                                    required>
                            </div>
                            <div class="col-md-6">
                                <label [for]="'last_name_' + i" class="form-label required">Last Name</label>
                                <input
                                    type="text"
                                    [name]="'last_name_' + i"
                                    class="form-control"
                                    [id]="'last_name_' + i"
                                    [(ngModel)]="formData.dependents[i].last_name"
                                    required>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label [for]="'relation_' + i" class="form-label required">Relation</label>
                                <select
                                    class="form-control"
                                    [name]="'relation_' + i"
                                    [id]="'relation_' + i"
                                    [(ngModel)]="formData.dependents[i].relation"
                                    (change)="onDependentRelationChange(i)"
                                    required>
                                    <option value="">-- Select Relation --</option>
                                    @if(shouldShowSpouseOption(i)) {
                                        <option value="spouse">Spouse</option>
                                    }
                                    <option value="child">Child</option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label [for]="'dob_' + i" class="form-label required">Date of Birth</label>
                                <input
                                    type="date"
                                    [name]="'dob_' + i"
                                    class="form-control"
                                    [id]="'dob_' + i"
                                    [(ngModel)]="formData.dependents[i].dob"
                                    (ngModelChange)="clearError()"
                                    [max]="todayIso"
                                    [class.is-invalid]="isFutureDate(formData.dependents[i].dob)"
                                    required>
                                @if (isFutureDate(formData.dependents[i].dob)) {
                                    <div class="invalid-feedback d-block">
                                        Date of Birth cannot be in the future.
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 d-flex justify-content-end flex-column">
                        <div class="d-flex flex-row">
                            @if(i === formData.dependents.length - 1 && formData.plan_type === 'Family' && formData.dependents.length < 8) {
                                <button type="button" class="btn btn-black w-25 me-2" (click)="addDependant()">+</button>
                            }
                            @if(i > 0) {
                                <button type="button" class="btn btn-white w-25" (click)="removeDependant(i)"><i class="bi-trash"></i></button>
                            }
                        </div>
                    </div>

                }
            }
            @if(displayErrorMessage()) {
                <div class="col-12">
                    <ngb-alert type="danger">
                        {{error()}}
                    </ngb-alert>
                </div>
            }
            <div class="col-md-6 offset-md-3 d-grid my-5">
                <button
                    class="btn btn-lg btn-black btn"
                    type="submit"
                    [disabled]="patientApplication.invalid || formData.phone.length !== 10 || hasFutureDob()"
                >Submit</button>
            </div>
        </form>
        } @else {
            <p #successMessage class="alert alert-success submission-success-message" tabindex="-1" role="alert">
                Your submission has been received. Please check the email address you provided for instructions to log in and review and accept the Family Health Advantage Terms and Conditions.
            </p>
        }
    </section>
</section>
